import DBModal from "../../../component/global/DBModal";
import DBSearchableTree from "../../../component/global/DBSearchableTree";
import DBModalTitle from "../../../component/global/DbModalTitle";
import { useTranslation } from "react-i18next";
import ReportItemTypeTreeDecorator from "./ReportItemTypeTreeDecorator";
import { useRequest } from "../../../hooks/helperData/useRequest";
import { SETTING_ITEMS_TYPE_TREE } from "../../../helperData/ApiAddress";
import { normalizeTreeResponse } from "../../../component/global/DBSearchableTree/treeUtils";
import DBSpinner from "../../../component/global/DBSpinner";
import { useEffect, useState } from "react";
import i18n from "./../../../i18n/i18n";
import DBInput from "../../../component/global/DBInput";
import DBButton from "../../../component/global/DBButton";

export default function ItemTypeTreeModal({ show, onHide, onChange }) {
    const { t } = useTranslation();
    const [companyList, setCompanyList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentItemType, setCurrentItemType] = useState();

    const [getCompanyList, companyListLoader] = useRequest(
        SETTING_ITEMS_TYPE_TREE,
        "GET"
    );

    useEffect(() => {
        if (show) {
            getCompanyList().then((r) => {
                setCompanyList([
                    {
                        id: 0,
                        name: t("all.groups"),
                        children: normalizeTreeResponse(r),
                    },
                ]);
            });
        }
    }, [show]);
    const itemTypeHandle = (e) => {
        setCurrentItemType(e.id);
    };

    return (
        <DBModal
            permanent
            show={show}
            minWidth={420}
            onHide={onHide}
            className="criteria-state-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                title={t("criteria.state.header")}
            />

            <DBModal.Content>
                <DBModalTitle>{t("itemtype.list")}</DBModalTitle>
                <div>
                    <DBInput
                        size="large"
                        placeholder={t("search")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="report-itemtype-list">
                    {companyListLoader ? (
                        <DBSpinner tip={t("loading")} />
                    ) : (
                        <DBSearchableTree
                            data={companyList}
                            searchTerm={searchTerm}
                            notfoundMessage={t("company.not.found")}
                            decorators={ReportItemTypeTreeDecorator}
                            selectedNodeHandle={itemTypeHandle}
                            direction={i18n.dir()}
                        />
                    )}
                </div>
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("apply")}
                    style={{ width: "100%" }}
                    onClick={() => onChange(currentItemType || undefined)}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
